import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const submitCorporateForm = createAsyncThunk("submitCorporateForm", async (data, { rejectWithValue }) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/website/business_inquiry`,
      data,
      config
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message);
  }
});

export { submitCorporateForm };